import {B2BUserScreens} from './types';
import OrderInfo from '../screens/orderInfo/OrderInfo';
import OrderItemInfo from '../screens/orderItemInfo/OrderItemInfo';
import React from 'react';
import Reschedule from '../screens/reschedule/Reschedule';
import ShopperInfo from '../screens/shopperInfo/ShopperInfo';
import UserLogin from '../screens/userLogin/UserLogin';
import {createNativeStackNavigator} from '@react-navigation/native-stack';

const Stack = createNativeStackNavigator();

const B2BUserNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{headerShown: false, gestureEnabled: false}}
      key={'B2BNavigator'}>
      <Stack.Screen name={B2BUserScreens.OrderInfo} component={OrderInfo} />
      <Stack.Screen name={B2BUserScreens.UserLogin} component={UserLogin} />
      <Stack.Screen name={B2BUserScreens.ShopperInfo} component={ShopperInfo} />
      <Stack.Screen
        name={B2BUserScreens.OrderItemInfo}
        component={OrderItemInfo}
      />
      <Stack.Screen name={B2BUserScreens.Reschedule} component={Reschedule} />
    </Stack.Navigator>
  );
};

export {B2BUserNavigator};
